import Image from 'next/image';
import { usePathname, useRouter } from 'next/navigation';
import { useState } from 'react';
import { Group, Menu, UnstyledButton } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import { switchLocaleAction } from '@/actions/switch-locale';
import { useTranslation } from '@/i18n/client';
import classes from './LanguagePicker.module.css';

export function LanguagePicker() {
  const [opened, setOpened] = useState(false);
  const pathname = usePathname();
  const { replace } = useRouter();
  const { lng, i18n } = useTranslation('translation');

  const handleLocaleChange = async (lang: 'ru' | 'en') => {
    await switchLocaleAction(lang);
    const oldLng = lng;
    i18n.changeLanguage(lang);
    if (pathname.includes(`/${oldLng}/`)) {
      replace(pathname.replace(`/${oldLng}/`, `/${lang}/`));
    } else {
      replace(pathname.replace(`/${oldLng}`, `/${lang}`));
    }
  };

  return (
    <Menu
      onOpen={() => setOpened(true)}
      onClose={() => setOpened(false)}
      radius='md'
      width='target'
      withinPortal
      trigger='hover'
    >
      <Menu.Target>
        <UnstyledButton className={classes.control} data-expanded={opened || undefined}>
          <Group gap='xs'>
            <Image
              src={`/static/images/lang/${lng}.png`}
              width={22}
              height={22}
              alt={lng.toUpperCase()}
            />
            <span className={classes.label}>{lng.toUpperCase()}</span>
          </Group>
          <IconChevronDown size={16} className={classes.icon} stroke={1.5} />
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<Image src='/static/images/lang/en.png' width={18} height={18} alt='EN' />}
          onClick={() => {
            handleLocaleChange('en');
          }}
        >
          EN
        </Menu.Item>
        <Menu.Item
          leftSection={<Image src='/static/images/lang/ru.png' width={18} height={18} alt='RU' />}
          onClick={() => {
            handleLocaleChange('ru');
          }}
        >
          RU
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}

export default LanguagePicker;
